var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"disabled":_vm.filterDisabled,"icon":_vm.$icons.filter},on:{"action":_vm.filter}})}
var staticRenderFns = []

export { render, staticRenderFns }